import { CurrentUserStore } from './models';

export const initialCurrentUserState: CurrentUserStore = {
  isFinancialAdvisor: false,
};
